import { HStack, Stack, Text, VStack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../../store/store_context";
import { useEffect } from "react";

const SelectPeriod = observer(() => {
  const { pageStore } = useStores();

  const setMonth = () => {
    const date = new Date();
    const start = new Date(date.getFullYear(), date.getMonth(), 1);
    start.setHours(23, 59, 59, 999);
    const end = new Date(start.getFullYear(), start.getMonth() + 1, 0);
    end.setHours(23, 59, 59, 999);

    pageStore.updateStartDateDay(start.toISOString().split("T")[0]);
    pageStore.updateEndDateDay(end.toISOString().split("T")[0]);
  };

  const setQuarter = () => {
    const date = new Date();
    const quarterStartMonth = Math.floor(date.getMonth() / 3) * 3;
    const start = new Date(date.getFullYear(), quarterStartMonth, 1);
    start.setHours(23, 59, 59, 999);
    const end = new Date(start.getFullYear(), start.getMonth() + 3, 0);
    end.setHours(23, 59, 59, 999);

    pageStore.updateStartDateDay(start.toISOString().split("T")[0]);
    pageStore.updateEndDateDay(end.toISOString().split("T")[0]);
  };

  const setFirstHalfYear = () => {
    const date = new Date();
    const start = new Date(date.getFullYear(), 0, 1);
    start.setHours(23, 59, 59, 999);
    const end = new Date(date.getFullYear(), 5, 30);
    end.setHours(23, 59, 59, 999);
    pageStore.updateStartDateDay(start.toISOString().split("T")[0]);
    pageStore.updateEndDateDay(end.toISOString().split("T")[0]);
  };

  const setSecondHalfYear = () => {
    const date = new Date();
    const start = new Date(date.getFullYear(), 6, 1);
    start.setHours(23, 59, 59, 999);
    const end = new Date(date.getFullYear(), 11, 31);
    end.setHours(23, 59, 59, 999);
    pageStore.updateStartDateDay(start.toISOString().split("T")[0]);
    pageStore.updateEndDateDay(end.toISOString().split("T")[0]);
  };

  const setYearToDate = () => {
    const date = new Date();
    const start = new Date(date.getFullYear(), 0, 1);
    start.setHours(23, 59, 59, 999);
    const end = new Date(date);
    end.setHours(23, 59, 59, 999);
    pageStore.updateStartDateDay(start.toISOString().split("T")[0]);
    pageStore.updateEndDateDay(end.toISOString().split("T")[0]);
  };

  const setTwoYear = () => {
    const date = new Date();
    const start = new Date(date.getFullYear() - 1, 0, 1);
    const end = new Date(date.getFullYear(), 11, 31, 23, 59, 59, 999);

    start.setHours(23, 59, 59, 999);

    pageStore.updateStartDateDay(start.toISOString().split("T")[0]);
    pageStore.updateEndDateDay(end.toISOString().split("T")[0]);
  };

  const setThreeYear = () => {
    const date = new Date();
    const start = new Date(date.getFullYear() - 2, 0, 1);
    const end = new Date(date.getFullYear(), 11, 31, 23, 59, 59, 999);

    start.setHours(23, 59, 59, 999);

    pageStore.updateStartDateDay(start.toISOString().split("T")[0]);
    pageStore.updateEndDateDay(end.toISOString().split("T")[0]);
  };

  useEffect(() => {
    // Период восстановлен из сохранённой настройки: даты уже пришли из неё,
    // пересчитывать их «от сегодня» нельзя. Раньше первый выбор настройки
    // затирал сохранённый период, а второй клик срабатывал верно — потому
    // что значение пресета уже не менялось и эффект не запускался.
    if (pageStore.period_from_bind) {
      pageStore.clearPeriodFromBind();
      return;
    }

    pageStore.updateStartDateMonth("");
    pageStore.updateEndDateMonth("");
    if (pageStore.selected_period == "month") {
      setMonth();
    } else if (pageStore.selected_period == "quarter") {
      setQuarter();
    } else if (pageStore.selected_period == "firstHalfYear") {
      setFirstHalfYear();
    } else if (pageStore.selected_period == "secondHalfYear") {
      setSecondHalfYear();
    } else if (pageStore.selected_period == "yearToDate") {
      setYearToDate();
    } else if (pageStore.selected_period == "twoYear") {
      setTwoYear();
    } else if (pageStore.selected_period == "threeYear") {
      setThreeYear();
    } else {
      pageStore.updateStartDateDay("");
      pageStore.updateEndDateDay("");
    }
  }, [pageStore.selected_period]);

  return (
    <VStack padding={"10px"} width={"100%"} borderRadius={"0px"}>
      <HStack
              mt="10px"
              justify="center"
              spacing={0}
              width="100%"
            >
        <Stack
          onClick={() => pageStore.updateSelectedPeriod("month")}
          height={"40px"}
          bg="#333"
          justify={"center"}
          align={"center"}
          w={{ base: "100%", md: "200px" }}
          borderRadius={"5px"}
          borderWidth={"2px"}
          borderColor={"#444"}
          cursor={"pointer"}
          color={"white"}
          padding={"5px"}
          _hover={{
            background: "#444",
          }}
        >
          <Text>Месяц</Text>
        </Stack>
        <Stack
          onClick={() => pageStore.updateSelectedPeriod("quarter")}
          height={"40px"}
          bg="#333"
          justify={"center"}
          align={"center"}
          w={{ base: "100%", md: "200px" }}
          borderWidth={"1px"}
          borderRadius={"2px"}
          borderColor={"#444"}
          cursor={"pointer"}
          padding={"5px"}
          color={"white"}
          _hover={{
            background: "#444",
          }}
        >
          <Text>Квартал</Text>
        </Stack>
        <Stack
          onClick={() => pageStore.updateSelectedPeriod("firstHalfYear")}
          height={"40px"}
          bg={pageStore.selected_period === "firstHalfYear" ? "#555" : "#333"}
          justify={"center"}
          align={"center"}
          w={{ base: "100%", md: "200px" }}
          borderWidth={"1px"}
          borderRadius={"2px"}
          cursor={"pointer"}
          borderColor={"#444"}
          color={"white"}
          padding={"5px"}
          _hover={{ background: "#444" }}
        >
          <Text fontSize={"13px"}>1-е полугодие</Text>
        </Stack>
        <Stack
          onClick={() => pageStore.updateSelectedPeriod("secondHalfYear")}
          height={"40px"}
          bg={pageStore.selected_period === "secondHalfYear" ? "#555" : "#333"}
          justify={"center"}
          align={"center"}
          w={{ base: "100%", md: "200px" }}
          borderWidth={"1px"}
          borderRadius={"2px"}
          cursor={"pointer"}
          borderColor={"#444"}
          color={"white"}
          padding={"5px"}
          _hover={{ background: "#444" }}
        >
          <Text fontSize={"13px"}>2-е полугодие</Text>
        </Stack>
        <Stack
          onClick={() => pageStore.updateSelectedPeriod("yearToDate")}
          height={"40px"}
          bg={pageStore.selected_period === "yearToDate" ? "#555" : "#333"}
          justify={"center"}
          align={"center"}
          w={{ base: "100%", md: "200px" }}
          borderWidth={"1px"}
          padding={"5px"}
          borderRadius={"2px"}
          borderColor={"#444"}
          cursor={"pointer"}
          color={"white"}
          _hover={{ background: "#444" }}
        >
          <Text fontSize={"13px"}>С начала года</Text>
        </Stack>
        <Stack
          onClick={() => pageStore.updateSelectedPeriod("twoYear")}
          height={"40px"}
          bg="#333"
          justify={"center"}
          align={"center"}
          w={{ base: "100%", md: "200px" }}
          borderWidth={"1px"}
          padding={"5px"}
          borderRadius={"2px"}
          borderColor={"#444"}
          cursor={"pointer"}
          color={"white"}
          _hover={{
            background: "#444",
          }}
        >
          <Text>2 года</Text>
        </Stack>
        <Stack
          onClick={() => pageStore.updateSelectedPeriod("threeYear")}
          height={"40px"}
          bg="#333"
          justify={"center"}
          align={"center"}
          w={{ base: "100%", md: "200px" }}
          borderWidth={"1px"}
          padding={"5px"}
          borderRadius={"2px"}
          borderColor={"#444"}
          cursor={"pointer"}
          color={"white"}
          _hover={{
            background: "#444",
          }}
        >
          <Text>3 года</Text>
        </Stack>
      </HStack>
    </VStack>
  );
});

export default SelectPeriod;
